var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuariosRegistrados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Locked-Icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4637 1.75002C7.26237 1.77802 4.66683 4.38435 4.66683 7.58335C4.66683 10.7823 7.26237 13.3887 10.4637 13.4167L10.4842 13.4167L10.5161 13.4167L10.5366 13.4167C13.738 13.3887 16.3335 10.7823 16.3335 7.58335C16.3335 4.38435 13.738 1.77802 10.5366 1.75002C10.525 1.74943 10.5118 1.75002 10.5002 1.75002L10.4637 1.75002L10.4637 1.75002ZM20.4168 14C16.8731 14 14.0002 16.8729 14.0002 20.4167C14.0002 23.9604 16.8731 26.8333 20.4168 26.8333C23.9606 26.8333 26.8335 23.9604 26.8335 20.4167C26.8335 16.8729 23.9606 14 20.4168 14L20.4168 14ZM3.85791 15.75C2.66091 15.75 1.6875 16.791 1.6875 18.0708L1.6875 18.9583C1.6875 20.8723 2.67648 22.5355 4.47314 23.641C5.98456 24.5714 7.99917 25.0833 10.1458 25.0833C11.5248 25.0833 12.8385 24.8591 14.0093 24.4601C13.2684 23.2888 12.8335 21.9053 12.8335 20.4167C12.8335 18.655 13.4399 17.0374 14.4479 15.75L3.85791 15.75L3.85791 15.75ZM20.4168 15.75C21.5427 15.75 22.4585 16.6658 22.4585 17.7917L22.4585 18.7077C22.9607 18.8378 23.3335 19.2903 23.3335 19.8333L23.3335 22.75C23.3335 23.3946 22.8114 23.9167 22.1668 23.9167L18.6668 23.9167C18.0222 23.9167 17.5002 23.3946 17.5002 22.75L17.5002 19.8333C17.5002 19.2903 17.8729 18.8378 18.3752 18.7077L18.3752 17.7917C18.3752 16.6658 19.291 15.75 20.4168 15.75L20.4168 15.75ZM20.4168 16.9167C19.9344 16.9167 19.5418 17.3093 19.5418 17.7917L19.5418 18.6667L21.2918 18.6667L21.2918 17.7917C21.2918 17.3093 20.8992 16.9167 20.4168 16.9167L20.4168 16.9167Z",
    id: "Forma",
    fill: "#304278",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosRegistrados);
export default __webpack_public_path__ + "static/media/usuarios_registrados.c27a9df64821af339febf8f242c681b8.svg";
export { ForwardRef as ReactComponent };